import styled from '@emotion/styled'

export const StyledErrorPage = styled.div`

    /* padding: 20px;
    height: 100vh; */
    
`